export const isEmailValid = (value: string): boolean => {
  return /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/.test(value);
};

export const isEmailPresent = (value: string): boolean => {
  return value.length > 0;
};
